import { UserType } from '@shared-features/enums/user-type.enum';
import { User } from '../models/user';

export class UpdateUserDto {
  id: number;
  firstName: string;
  lastName: string;
  email?: string;
  mobileNumber?: string;
  countryId?: number;
  status: string;
  roleIds: number[];
  userType?: UserType;
  shippingType?: string;
  allowToLogin?: boolean;
  params?: any[];

  constructor(user: Partial<User>) {
    this.id = user.id;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.email = user.email;
    this.mobileNumber = user.mobileNumber;
    this.countryId = user.country?.id;
    this.status = user.status;
    this.roleIds = user?.roles?.map((role) => role.id);
    this.userType = user?.roles?.[0]?.userType;
    this.shippingType = user.shippingType;
    this.allowToLogin = user.allowToLogin;
    this.params = user.params || [];
  }
}
